<template>
  <div class="home">
    <v-card v-if="!isSP" flat>
      <v-img :src="`/image/${imageNum}-min.jpg`" style="width:100vw; height:100vh">
        <v-app-bar flat dense color="rgba(255, 255, 255, 0.0)">
          <span class="headerBox">{{timeString}}</span>
          <v-spacer></v-spacer>
          <a href="https://crieit.net/boards/web1week-202009/870da7cd962f4c6f36701afac0838f98">
            <v-icon>{{mdiAlertCircleOutline}}</v-icon>
          </a>
        </v-app-bar>
        <v-card flat class="textBox" style="">
          <v-card-text>{{message}}</v-card-text>
        </v-card>
      </v-img>
    </v-card>
    <v-card v-if="isSP" flat>
        <v-app-bar flat dense color="rgba(255, 255, 255, 0.0)">
          <span class="headerBox">{{timeString}}</span>
          <v-spacer></v-spacer>
          <a href="#">
            <v-icon>{{mdiAlertCircleOutline}}</v-icon>
          </a>
        </v-app-bar>
        <v-img :src="`/image/${imageNum}-min.jpg`" aspect-ratio=0.65></v-img>
        <v-card flat class="textBoxSP" style="">
          <v-card-text>{{message}}</v-card-text>
        </v-card>
    </v-card>
  </div>
</template>

<script>
import { mdiAlertCircleOutline } from '@mdi/js';
// @ is an alias to /src
export default {
  name: 'Home',
  computed: {
    displaySize () {
      return this.$vuetify.breakpoint.name
    },
    isSP () {
      if (this.displaySize==='xs' || this.displaySize==='sm') return true
      return false
    }
  },
  data () {
    return {
      sec: 0,
      imageNum: '',
      imax: 30,
      interval: 60,
      timeString: '',
      message: '',
      mdiAlertCircleOutline: mdiAlertCircleOutline,
      phrases: [
        'あきらめたら試合終了だよ！',
        'いつまでこっち見てるのよ。早くコード書きなさいよ！',
        'バスケがしたいです？いいからコード書きなさいよ！',
        'やればできる！　ティモンディ風に言ってみて💛',
        '負けないで もう少し 最後まで 走り抜けて',
        'あなたのプロダクトを待ってる人がどこかにいるから！',
        '悩むのはリリースした後だよ。リリースしよ？',
        'テーマなんて適当でいいのよ。',
        'いつまで悩んでるのよ。目の前にはPCがあるじゃない？やることは決まったね？',
        'できるできないじゃない、やるかやらないかだよ。',
        'バグがないコードなんてないんだから。大体動けばいいよ。',
        '何度失敗しても続けている間は負けじゃない！まだおわりじゃないよ！',
        'あと少しだよ。あと少しだけコード書こう？',
        '時間がないのに機能を詰め込むのはよくないぞ。',
        'コードが汚いとか気にしてるからリリースできないんだよ。',
        'さあ、なにを創ろうか？',
        '大丈夫。まだ慌てるような時間じゃないよ。',
        'どんなWebサービスも使ってくれるユーザーのためにあるんだよ。ちゃんとユーザーのこと想像できてる？',
        'ひとつの作業に完璧を求めすぎちゃだめだよ。',
        '失敗をおそれるな！ぶつかっていけー！！',
        'あなたのサービス、一言で表現すると何なの？',
        'ちょっと複雑になってない？シンプル過ぎるくらいの方が好きだなー',
        'ユーザーは技術的難易度なんて気にしてないよ。サービスとして提供価値が大きくなることからやらないとダメ。',
        '早くキミのサービスが見たいなぁ...',
      ]
    }
  },
  mounted () {
    // this.showImage()
    let self = this;
    setInterval(function() {self.loop()}, 1000)
  },
  methods: {
    loop () {
      this.sec++
      this.time()
    },
    time () {
      let date = new Date()
      let timeString = `${this.pad(date.getHours())}：${this.pad(date.getMinutes())}`
      if (this.timeString !== timeString) {
        this.showImage()
        this.changeMessage()
        this.timeString = timeString
        this.$emit('updateHead')
      }
    },
    showImage () {
      this.imageNum = Math.floor(Math.random() * this.imax) + 1
    },
    changeMessage () {
      let idx = Math.floor(Math.random() * this.phrases.length) + 1
      this.message = this.phrases[idx]
    },
    pad (v) {
      let vv = v + ''
      if (vv.length === 1) {
        return '0' + vv
      } else {
        return vv
      }
    }
  },
  components: {
  },
  head: {
    title () {
      return {
        inner: `${this.timeString}`,
        separator: '-',
        complement: 'ツインテール時計'
      }
    }
  }
}
</script>
<style scoped>
.headerBox {
  background: rgba(255, 255, 255, 0.3);
  padding: 5px 10px;
  border-radius:16px;
}
.textBox {
  position:absolute;
  bottom:20px;
  right:20px;
  background: rgba(255, 255, 255, 0.5) !important;
  border-radius:20px !important;
}
.textBox >>> .v-card__text {
  font-size: 20pt;
}
.textBoxSP >>> .v-card__text {
  font-size: 16pt;
  line-height: 1.8rem
}
</style>